<template>
    <div class="p-grid">
        <Toast />
        <div class="p-col-12">
            <div class="card p-fluid">
                <h4>
                    <strong>{{ $t('Purchase.list.Search') }}</strong>
                </h4>
                <div class="p-formgrid p-grid p-mb-3">
                    <div class="p-field p-col-12 p-md-3">
                        <label for="nameuser">{{ $t('Purchase.list.Type') }}</label>
                        <Dropdown :value="type" v-model="type" :options="Typesdropdown" optionLabel="name" optionValue="code" :placeholder="$t('Purchase.list.Select')" name="name" id="first_category" />
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                        <label for="title">{{ $t('Purchase.list.Email') }}</label>
                        <InputText :value="email" id="title" type="text" :placeholder="$t('Purchase.list.SBEmail')" v-model="email" />
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                        <label for="pass">{{ $t('Purchase.list.Start Date') }}</label>
                        <Calendar :value="start_date" :showIcon="true" :maxDate="maxDateValue" :showButtonBar="false" v-model="start_date" dateFormat="yy.mm.dd" placeholder="YYYY-MM-DD" :manualInput="false" :max-date="new Date()"> </Calendar>
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                        <label for="pass">{{ $t('Purchase.list.End Date') }}</label>
                        <Calendar :value="end_date" :showIcon="true" :maxDate="maxDateValue" :showButtonBar="false" v-model="end_date" dateFormat="yy.mm.dd" placeholder="YYYY-MM-DD" :manualInput="false" :max-date="new Date()"> </Calendar>
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                        <label for="title">{{ $t('Purchase.list.Phone') }}</label>
                        <InputText :value="phone" id="title" type="text" :placeholder="$t('Purchase.list.SBPhone')" v-model="phone" maxlength="11" onkeypress="return /[0-9]/i.test(event.key)" />
                    </div>
                </div>

                <div class="p-d-flex p-jc-between p-ai-lg-center p-ai-start p-mt-6 p-flex-column p-flex-lg-row">
                    <div class="p-mb-4 p-mb-lg-0">
                        <!-- <Button :label="$t('button.today')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="today"></Button>
                        <Button :label="$t('button.lastWeek')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastweek"></Button>
                        <Button :label="$t('button.lastMonth')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastmonth"></Button>
                        <Button :label="$t('button.last6Months')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastsixmonth"></Button>
                         <Button :label="$t('button.lastYear')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastyear"></Button>  -->
                    </div>
                    <div class="p-mb-4 p-mb-lg-0">
                        <Button :label="$t('button.search')" icon="pi pi-search" iconPos="left" class="p-button p-component p-button p-button-sm p-mr-2 p-mb-2" @click="SearchProduct"></Button>
                        <Button :label="$t('button.reset')" icon="pi pi-replay" iconPos="left" class="p-button p-component p-button p-button-sm p-mr-2 p-mb-2" @click="resetUser"></Button>
                    </div>
                </div>
            </div>
        </div>
        <div class="p-col-12">
            <div class="card">
                <div class="p-d-flex p-jc-between p-mb-2">
                    <div>
                        <h5>{{ $t('Purchase.list.RecruiterList') }}</h5>
                    </div>
                </div>
                <div class="p-mb-4 p-mb-lg-0 page p-d-flex p-jc-between p-mb-2">
                    <label for="order"
                        >{{ $t('Purchase.list.Record') }} {{ pagination.total_records }}
                        <Dropdown class="p-ml-2" id="order" v-model="pagination.pagination_limit" :options="pagination_limit_options" optionLabel="label" optionValue="value" placeholder="10개씩 보기" />
                    </label>

                    <router-link :to="'/PurchaseManagement/AddNewPurchase'">
                        <Button label="Primary" class="p-mr-2 p-mb-2">{{ $t('Purchase.list.AddNew') }}</Button>
                    </router-link>
                </div>
                <br />
                <DataTable :value="results" :paginator="false" class="p-datatable-gridlines" :rows="10" dataKey="id" :loading="loading1" :rowHover="true" :filters="filters1" responsiveLayout="scroll">
                    <!-- v-model:selection="selected" -->
                    <ConfirmDialog group="dialog" />

                    <template #empty>문의를 찾을 수 없습니다</template>
                    <template #loading>어드민 정보 로딩중..</template>
                    <!-- <column selectionMode="multiple" style="width: 16px; text-align: center" /> -->
                    <Column field="slNO" :header="$t('Purchase.list.No')" style="min-width: 5rem">
                        <template #body="{ index }">
                            <span class="p-column-title">#</span>
                            {{ pagination.current_page * pagination.pagination_limit - pagination.pagination_limit + (index + 1) }}
                        </template>
                    </Column>
                    <Column field="name" :header="$t('Purchase.list.UserName')" style="min-width: 10rem">
                        <template #body="{ data }">
                            <span class="p-column-title">UserName</span>
                            {{ data.company_name == null ? '---' : data.company_name }}
                        </template>
                    </Column>
                    <Column field="name" :header="$t('Purchase.list.Type')" style="min-width: 10rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Type</span>
                            {{ data.stype_name == null ? '---' : data.stype_name }}
                        </template>
                    </Column>
                    <Column :header="$t('Purchase.list.Email')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Email</span>
                            {{ data.email == null ? '---' : data.email }}
                        </template>
                    </Column>
                    <Column :header="$t('Purchase.list.Phone')" style="min-width: 10rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Phone</span>
                            {{ data.phone_number == null ? '---' : formatPhoneNumber(data.phone_number) }}
                        </template>
                    </Column>
                    <Column :header="$t('Purchase.list.Validtime')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Valid time</span>
                            {{ data.validity == null ? '---' : `${data.validity}` }} {{ $t('Days') }}
                        </template>
                    </Column>
                    <Column :header="$t('Purchase.list.Noofcases')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">No of cases</span>
                            {{ data.cases == null ? '---' : data.cases }}
                        </template>
                    </Column>
                    <Column :header="$t('Purchase.list.Discountrate')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Discount rate</span>
                            {{ data.discount_price == null ? '---' : data.discount_price + '%' }}
                        </template>
                    </Column>
                    <Column :header="$t('Purchase.list.Originalprice')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Original price</span>
                            {{ data.main_original_price == null ? '---' : data.main_original_price + '&nbsp;' + '초코' }}
                        </template>
                    </Column>
                    <Column :header="$t('Purchase.list.Offeredprice')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Offered price</span>
                            {{ data.main_price == null ? '---' : data.main_price + '&nbsp;' + '초코' }}
                        </template>
                    </Column>
                    <Column :header="$t('Purchase.list.PurchaseDate')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Purchase Date</span>
                            {{ data.date == null ? '---' : FormatDate(data.date) }}
                        </template>
                    </Column>
                    <Column :header="$t('Purchase.list.AppliedDate')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Applied Date</span>
                            {{ data.applied_date == null ? '---' : FormatDate(data.applied_date) }}
                        </template>
                    </Column>
                    <Column :header="$t('Purchase.list.Status')" style="min-width: 8rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Status</span>
                            <p id="round">{{ $t(data.is_refunded == '1' ? $t('refunded') : $t(data.status)) }}</p>
                        </template>
                    </Column>
                    <Column :header="$t('JobSeekers.list.Action')" style="min-width: 6rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Balance</span>
                            <!-- <p style="display: none">{{ data.mobile }}</p> -->
                            <div style="display: flex">
                                <!-- <router-link :to="'/MemberManagement/JobSeeker/ViewJobSeeker/' + data.id"
                                    ><Button label="info" class="p-button2"><i class="pi pi-eye p-mr-2"></i> </Button>
                                </router-link> -->
                                <router-link :to="'/PurchaseManagement/ViewPurchaseManagement/' + data.id"
                                    ><Button label="info" class="p-button2"><i class="pi pi-user-edit p-mr-2"></i> </Button>
                                </router-link>
                                <!-- <Button icon="pi pi-trash" class="p-button2" @click="confirm(data.id)" /> -->
                            </div>
                        </template>
                    </Column>
                </DataTable>
                <div class="p-paginator p-component p-paginator-bottom">
                    <button @click="paginate(1)" :class="{ 'p-disabled': pagination.current_page === 1 }" class="p-paginator-first p-paginator-element p-link" type="button" :disabled="pagination.current_page === 1">
                        <span class="p-paginator-icon pi pi-angle-double-left"></span>
                        <span class="p-ink"></span>
                    </button>
                    <button @click="paginate(pagination.current_page - 1)" :class="{ 'p-disabled': pagination.current_page === 1 }" class="p-paginator-next p-paginator-element p-link" type="button" :disabled="pagination.current_page === 1">
                        <span class="p-paginator-icon pi pi-angle-left"></span>
                        <span class="p-ink"></span>
                    </button>
                    <span class="p-paginator-pages">
                        <button
                            v-for="(page, index) in get_paginator_page(pagination.total_pages, pagination.current_page)"
                            :key="index"
                            @click="paginate(page)"
                            class="p-paginator-page p-paginator-element p-link"
                            :class="{ 'p-highlight': page === pagination.current_page }"
                            type="button"
                        >
                            {{ page }}<span class="p-ink"></span>
                        </button>
                    </span>
                    <button
                        @click="paginate(pagination.current_page + 1)"
                        :class="{ 'p-disabled': pagination.current_page === pagination.total_pages }"
                        class="p-paginator-next p-paginator-element p-link"
                        type="button"
                        :disabled="pagination.current_page === pagination.total_pages"
                    >
                        <span class="p-paginator-icon pi pi-angle-right"></span>
                        <span class="p-ink"></span>
                    </button>
                    <button
                        @click="paginate(pagination.total_pages)"
                        :class="{ 'p-disabled': pagination.current_page === pagination.total_pages }"
                        :disabled="pagination.current_page === pagination.total_pages"
                        class="p-paginator-last p-paginator-element p-link"
                        type="button"
                    >
                        <span class="p-paginator-icon pi pi-angle-double-right"></span>
                        <span class="p-ink"></span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import { useRoute } from 'vue-router';
// import validateUsersearch from '../../validations/user/validateUserSearch';
// import { FilterMatchMode, FilterOperator } from 'primevue/api';
import PurchaseService from '../../service/API/PurchaseService';
import axios from 'axios';
import moment from 'moment';
import utils from '@/service/utils';
// import ProductService from '../service/ProductService';
// import axios from 'axios';
export default {
    data() {
        return {
            id: 6,
            payment_history_id: '',
            ad_type_id: '',
            ad_sub_type_id: '',
            ad_package_id: '',
            employer_id: '',
            job_id: '',
            sub_type: '',
            is_gifted: '',
            validity_date: '',
            discount: '',
            original_price: '',
            discounted_price: '',
            no_of_cases: '',
            status: '',
            is_refunded: '',
            note: '',
            applied_date: '',
            expired_date: '',
            created_at: '',
            updated_at: '',
            stype_name: '',
            company_name: '',
            phone_number: '',
            email: '',
            date: '',
            loading1: true,
            idFrozen: false,
            products: null,
            expandedRows: [],
            user: null,
            Typesdropdowns: '',
            start_date: '',
            end_date: '',
            startDate: '',
            endDate: '',
            phone: '',
            Typesdropdown: [
                { name: '스페셜', code: 'Special' },
                { name: '프리미엄', code: 'Premium' },
                { name: '업글', code: 'Upgle' },
                { name: '라인(무료)', code: 'Free' },
                { name: '라인', code: 'Line' },
                { name: '인재 검색', code: 'Talent Search' },
                { name: '긴급', code: 'Emergency' },
            ],
            statuses: ['unqualified', 'qualified', 'new', 'negotiation', 'renewal', 'proposal'],
            genders: [
                { name: 'Statistical', code: 'Statistical' },
                { name: 'Coupon', code: 'Coupon' },
                { name: 'Survey reminder', code: 'Survey reminder' },
                { name: 'Manual', code: 'Manual' },
            ],
            pets: [
                { name: 'Yes', code: 'Yes' },
                { name: 'No', code: 'No' },
            ],
            marital_statuss: [
                { name: 'married', code: 'married' },
                { name: 'unmarried', code: 'unmarried' },
            ],
            age_groups: [
                { name: '25~35', code: '25 ~ 35' },
                { name: '35~45', code: '35 ~ 45' },
                { name: '45~55', code: '45 ~ 55' },
                { name: '55~65', code: '55 ~ 65' },
            ],
            dropdownItem: null,
            error: {},
            //params for list
            Ntitle: '',
            Ntype: '',
            type: '',
            // start_date: '',
            // end_date: '',
            notification_type: '',
            productCategoryStatus: '',
            pagination_limit_options: [
                { label: '10개씩 보기', value: 10 },
                { label: '20개씩 보기', value: 20 },
                { label: '50개씩 보기', value: 50 },
                { label: '100개씩 보기', value: 100 },
            ],
            pagination: {
                current_page: 1,
                pagination_limit: 10,
                total_pages: 0,
                total_records: 0,
            },
            result: [],
            SearchTo: '',
            SerachFrom: '',
        };
    },
    customerService: null,
    productService: null,
    created() {
        this.purchaseService = new PurchaseService();
        // this.phone = localStorage.getItem('purchase_phone')
        // this.start_date = localStorage.getItem('start_date') ? moment(localStorage.getItem('start_date')).format('YYYY-MM-DD') : ''
        // this.end_date = localStorage.getItem('end_date') ? moment(localStorage.getItem('end_date')).format('YYYY-MM-DD') : ''
        // this.type = localStorage.getItem('purchase_type')
        // this.email = localStorage.getItem('purchase_email')
        // const params = {
        //     email: this.email,
        //     phone: this.phone,
        //     type: this.type,
        //     start_date: this.start_date,
        //     end_date: this.end_date,
        // };
        // this.callAPI(params);
    },
    mounted() {
        // this.getPClist();
        this.storageData = localStorage.getItem('PurchaseManagement') ? JSON.parse(localStorage.getItem('PurchaseManagement')) : '';

        if (this.storageData != '') {
            this.PurchasePagination = this.storageData.current_page;
            this.email = this.storageData.email == undefined ? '' : this.storageData.email;
            this.phone = this.storageData.phone == undefined ? '' : this.storageData.phone;
            this.type = this.storageData.type == undefined ? '' : this.storageData.type;
            let FromDate = this.storageData.start_date ? new Date(this.storageData.start_date) : '';
            this.start_date = FromDate;
            let ToDate = this.storageData.end_date ? new Date(this.storageData.end_date) : '';
            this.end_date = ToDate;
        }
        if (this.PurchasePagination == '' || this.PurchasePagination == null) {
            if (this.start_date || this.email || this.end_date || this.note || this.type || this.phone) {
                const searchLocalParams = {
                    page: this.pagination.current_page,
                    limit: this.pagination.pagination_limit,
                    email: this.storageData.email == undefined ? '' : this.storageData.email,
                    phone: this.storageData.phone == undefined ? '' : this.storageData.phone,
                    type: this.storageData.type == undefined ? '' : this.storageData.type,
                    start_date: this.start_date == undefined || NaN ? '' : this.start_date ? this.start_date : '',
                    end_date: this.end_date == undefined || NaN ? '' : this.end_date ? this.end_date : '',
                };
                this.getPClist(searchLocalParams);
            } else {
                this.getPClist({ limit: this.pagination.pagination_limit, page: this.pagination.current_page });
            }
        } else {
            const searchLocalParams = {
                page: this.PurchasePagination,
                limit: this.pagination.pagination_limit,
                email: this.storageData.email == undefined ? '' : this.storageData.email,
                phone: this.storageData.phone == undefined ? '' : this.storageData.phone,
                type: this.storageData.type == undefined ? '' : this.storageData.type,
                start_date: this.start_date == undefined || NaN ? '' : this.start_date ? this.start_date : '',
                end_date: this.end_date == undefined || NaN ? '' : this.end_date ? this.end_date : '',
            };
            this.getPClist(searchLocalParams);
        }
        // this.StorageSearch();
    },
    //   beforeUnmount(){
    //     localStorage.removeItem('purchase_phone');
    //     localStorage.removeItem('start_date');
    //     localStorage.removeItem('end_date');
    //     localStorage.removeItem('purchase_type');
    //     localStorage.removeItem('purchase_email');
    //   },
    watch: {
        'pagination.pagination_limit'(val) {
            this.getPClist({ limit: val, page: 1 });
        },
    },
    methods: {
        // callAPI(val) {},
        getPClist(data) {
            // const adminlistParams = {
            //     page: 1,
            //     limit: this.pagination.pagination_limit,
            // };
            this.loading1 = true;
            this.purchaseService
                .GetPurchaseList(data)
                .then((res) => {
                    this.results = res.data.result;
                    this.totalrecords = res.data.total_records;
                    this.setPagination(res.data.current_page, res.data.total_pages === 0 ? 1 : res.data.total_pages, res.data.total_records);
                    this.loading1 = false;
                    // console.log(res);
                })
                .catch((err) => console.log(err));
            // this.callAPI(adminlistParams);
        },

        setPagination(current_page, total_pages, total_records) {
            this.pagination.current_page = current_page;
            this.pagination.total_pages = total_pages;
            this.pagination.total_records = total_records;
        },
        get_paginator_page(total, active) {
            return utils.paginate(total, active);
        },

        paginate(page) {
            this.loading = true;
            localStorage.setItem(
                'PurchaseManagement',
                JSON.stringify({
                    current_page: page,
                    // limit: this.pagination.pagination_limit,
                    phone: this.phone,
                    email: this.email,
                    type: this.type,
                    start_date: this.SerachFrom,
                    end_date: this.SearchTo,
                })
            );
            this.purchaseService
                .GetPurchaseList({
                    page: page,
                    limit: this.pagination.pagination_limit,
                    email: this.email,
                    type: this.type,
                    phone: this.phone,
                    start_date: this.SerachFrom,
                    end_date: this.SearchTo,
                    // start_date: this.start_date ? moment(this.start_date).format('YYYY-MM-DD') : '',
                    // end_date: this.end_date ? moment(this.end_date).format('YYYY-MM-DD') : '',
                })
                .then((res) => {
                    this.results = res.data.result;
                    this.pagination.current_page = page;
                    this.loading = false;
                    // console.log(res.data);
                })
                .catch((err) => console.log(err));
        },
        resetUser() {
            // localStorage.setItem('purchase_phone', '');
            // localStorage.setItem('start_date', '');
            // localStorage.setItem('end_date', '');
            // localStorage.setItem('purchase_type', '');
            // localStorage.setItem('purchase_email', '');
            (this.email = ''), (this.phone = ''), (this.type = ''), (this.start_date = '');
            this.end_date = '';
            localStorage.setItem('PurchaseManagement', '');
            this.getPClist();
            window.location.reload();
        },
        FormatDate(value) {
            if (value) {
                return moment(String(value)).format('YYYY.MM.DD');
            }
        },
        addDay(val) {
            const date = new Date(val);
            var dd = date.getDate();
            var mm = date.getMonth() + 1;
            var yyyy = date.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            return (val = yyyy + '-' + mm + '-' + dd);
        },
        SearchProduct() {
            if (this.phone == '' && this.start_date == '' && this.end_date == '' && this.email == '' && this.type == '') {
                // console.log(this.productCategoryStatus);
                this.$toast.add({ severity: 'error', summary: '에러 메시지', detail: '1개 이상의 검색 값을 입력하세요.', life: 3000 });
            } else if (this.start_date !== '' && this.end_date == '') {
                // console.log(this.productCategoryStatus);
                this.$toast.add({ severity: 'error', summary: '에러 메시지', detail: '일자 기간을 설정해 주세요.', life: 3000 });
            } else if (this.start_date == '' && this.end_date !== '') {
                // console.log(this.productCategoryStatus);
                this.$toast.add({ severity: 'error', summary: '에러 메시지', detail: '일자 기간을 설정해 주세요.', life: 3000 });
            } else {
                localStorage.setItem(
                    'PurchaseManagement',
                    JSON.stringify({
                        page: 1,
                        // limit: this.pagination.pagination_limit,
                        email: this.email,
                        phone: this.phone,
                        type: this.type,
                        start_date: this.SerachFrom,
                        end_date: this.SearchTo,
                    })
                );
                // localStorage.setItem('purchase_phone', this.phone);
                // localStorage.setItem('start_date', this.start_date);
                // localStorage.setItem('end_date', this.end_date);
                // localStorage.setItem('purchase_type', this.type);
                // localStorage.setItem('purchase_email', this.email);

                if (this.start_date != '') {
                    this.SerachFrom = this.addDay(this.start_date);
                } else {
                    this.SerachFrom = '';
                }
                if (this.end_date != '') {
                    this.SearchTo = this.addDay(this.end_date);
                } else {
                    this.SearchTo = '';
                }

                let searchParams = {
                    limit: this.pagination.pagination_limit,
                    page: 1,
                    email: this.email,
                    phone: this.phone,
                    type: this.type,
                    start_date: this.SerachFrom,
                    end_date: this.SearchTo,
                };
                this.loading = true;
                this.purchaseService
                    .GetPurchaseList(searchParams)
                    .then((res) => {
                        this.results = res.data.result;
                        this.loading1 = false;
                        this.setPagination(res.data.current_page, res.data.total_pages === 0 ? 1 : res.data.total_pages, res.data.total_records);
                    })
                    .catch(() => {
                        this.results = [];
                        this.loading1 = false;
                    });
                // this.callAPI(searchParams);
                this.loading = false;
            }
        },

        // searchproduct() {
        //     if (this.first_category == '' && this.second_category == '' && this.third_category == '' && this.productCategoryStatus == '') {
        //         console.log(this.productCategoryStatus);
        //         this.$toast.add({ severity: 'error', summary: 'Error message', detail: '1개 이상의 검색 값을 입력하세요.', life: 3000 });
        //     } else {
        //         // this.getlist();
        //     }
        // },
        exceldownload() {
            this.productCategoryService.getExcel(this.first_category, this.second_category, this.third_category, this.productCategoryStatus?.code).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Productcategorylist.xlsx'); //or any other extension
                document.body.appendChild(link);
                link.click();
            });
        },
        today() {
            const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '.');
            this.start_date = utc;
            this.end_date = utc;
            this.getlist();
            console.log(this.start_date);
        },
        lastweek() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 7);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
            console.log(this.start_date);
        },
        lastmonth() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 31);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
            console.log(this.start_date);
        },
        lastsixmonth() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 182);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
            console.log(this.start_date);
        },
        getParams(NotificationType) {
            localStorage.setItem('NotificationType', NotificationType);
            console.log(NotificationType);
        },
        open() {
            this.display = true;
        },
        close() {
            this.display = false;
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },

        onRowExpand(event) {
            this.$toast.add({ severity: 'info', summary: 'Product Expanded', detail: event.data.name, life: 3000 });
        },
        onRowCollapse(event) {
            this.$toast.add({ severity: 'success', summary: 'Product Collapsed', detail: event.data.name, life: 3000 });
        },
        expandAll() {
            this.expandedRows = this.products.filter((p) => p.id);
            this.$toast.add({ severity: 'success', summary: 'All Rows Expanded', life: 3000 });
        },
        collapseAll() {
            this.expandedRows = null;
            this.$toast.add({ severity: 'success', summary: 'All Rows Collapsed', life: 3000 });
        },
        formatCurrency(value) {
            return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        },
        formatDate(value) {
            const date = new Date(value);
            var dd = date.getDate();
            var mm = date.getMonth() + 1;
            var yyyy = date.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            return (value = yyyy + '.' + mm + '.' + dd);
        },
        calculateCustomerTotal(name) {
            let total = 0;
            if (this.customer3) {
                for (let customer of this.customer3) {
                    if (customer.representative.name === name) {
                        total++;
                    }
                }
            }

            return total;
        },
        acceptNumber() {
            var x = this.phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            this.phone = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
        },
        formatPhoneNumber(num) {
            var cleaned = ('' + num).replace(/\D/g, '');
            if (num.toString().length == '11') {
                var match = cleaned.match(/^(\d{3})(\d{4})(\d{4})$/);
                if (match) {
                    return '(' + match[1] + ') ' + match[2] + ' - ' + match[3];
                }
                return null;
            } else if (num.toString().length == '10') {
                var match1 = cleaned.match(/^(\d{2})(\d{4})(\d{4})$/);
                if (match1) {
                    return '(' + match1[1] + ') ' + match1[2] + ' - ' + match1[3];
                }
                return null;
            } else if (num.toString().length == '9') {
                var match2 = cleaned.match(/^(\d{1})(\d{4})(\d{4})$/);
                if (match2) {
                    return '(' + match2[1] + ') ' + match2[2] + ' - ' + match2[3];
                }
                return null;
            }
        },
        confirm(id) {
            var self = this;
            this.$confirm.require({
                group: 'dialog',
                header: '확인',
                message: '삭제하시겠습니까?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: '확인',
                rejectLabel: ' 취소',
                accept: () => {
                    axios({ method: 'delete', url: `/product-category/${id}` }).then(function () {});
                    self.$toast.add({ severity: 'info', summary: '삭제', detail: '성공적으로 삭제되었습니다.', life: 3000 });
                    self.productCategoryService.getProductCategoryList(self.first_category, self.second_category, self.third_category, self.productCategoryStatus).then((data) => {
                        console.log(data);
                        this.customer1 = data;
                        this.loading1 = false;
                        this.customer1.forEach((customer) => (customer.createdDate = new Date(customer.createdDate)));
                    });
                },
                reject: () => {
                    this.$toast.add({ severity: 'error', summary: '오류가 발생했습니다', detail: '취소되었습니다', life: 3000 });
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.p-datatable-tbody {
    .p-button {
        white-space: nowrap;
    }
}

.p-fluid {
    .p-button {
        width: auto;
    }
}

// .p-button {
//     background-color: black;
//     color: white;
//     border-color: black;
// }
.p-button {
    background: white;
    // border: 1px solid #0A0A0A;
    color: black;
}

p#round {
    border-radius: 12px;
    border: 1px solid black;
}
</style>
